import React, { Component } from 'react';
import { Growl } from 'primereact/growl';
import { Dropdown } from 'primereact/dropdown';
import { Message } from 'primereact/message';
import { InputTextarea } from 'primereact/inputtextarea';
import { Archivo } from '../componentes/Archivo';
import { obtenerBytesBase64Archivos } from '../servicio/ServicioLecturaArchivos';
import servicioHttp from '../servicio/ServicioHttp';
import servicioObjetos from '../servicio/ServicioObjetos';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import servicioArchivos from '../servicio/ServicioArchivos';
const MENSAJE_REQUERIDO = "Dato requerido";
export class TabImportarDatos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            datosImprocesados:[],
            objetoPdf:{},
            respuesta: {},
            movimiento: {},
            errores: {},
            tiposImportacion: [
                { value: '1', label: 'TRABAJADORES (ASEG.TXT)' },
                { value: '2', label: 'DATOS AFILIATORIOS (AFIL.TXT)' },
                { value: '3', label: 'MOVIMIENTOS (MOVT.TXT)' },
                { value: '4', label: 'MOVIMIENTOS DE CREDITO (CRED.TXT)' },
                { value: '5', label: 'DATOS DE INCAPACIDADES (INCAP.TXT)' },
            ],
            mostrarDialogExaminar: false,
            nombreArchivo: null
        }
    }
    asignarValores = (event) => {
        servicioObjetos.asignarAtributosObjeto(event, this);
    }
    cargarArchivo = (event) => {
        obtenerBytesBase64Archivos(event, this);
        let nombreArchivo = event.target.files[0].name;
        this.setState({ nombreArchivo: nombreArchivo });

    }
    enviarArchivo = () => {
        let { movimiento, respuesta, datosImprocesados } = this.state;
        respuesta.mensaje ="";
        this.setState({datosImprocesados:[],respuesta});
       
        movimiento.tipoArchivo = movimiento.tipoArchivo.value;
        servicioHttp.consumirPostHttp('/importar/cargar.json', movimiento).then(response => {
            if (!response.data.error) {
                respuesta.mensaje = response.data.objeto.mensaje;
                datosImprocesados = response.data.objeto.listaDatosError;
                this.setState({objetoPdf:response.data.objeto,movimieto:{},datosImprocesados, respuesta, mostrarDialogExaminar:false });
                this.growl.show({ severity: 'success', summary: 'Aviso', detail: response.data.mensaje, life: 6000 });
                movimiento.tipoArchivo = null;
                movimiento.archivo = null;
                this.setState({movimiento});


            } else {
                this.setState({ movimieto:{},respuesta, mostrarDialogExaminar:false });
                this.growl.show({ severity: 'error', summary: 'Aviso', detail: response.data.mensaje, life: 6000 });
                movimiento.tipoArchivo = null;
                movimiento.archivo = null;
                this.setState({movimiento});
            }
        }).catch(error => {
            this.growl.show({ severity: 'error', summary: 'Aviso', detail: "error en el servidor", life: 6000 });
            this.setState({ movimieto:{}});
            movimiento.tipoArchivo = null;
                movimiento.archivo = null;
                this.setState({movimiento});
        });
    }

    validarFormulario = () => {
        let { movimiento } = this.state;
        let errores = {};

        if (servicioObjetos.esObjetoVacio(movimiento.tipoArchivo))
            errores.tipoArchivo = MENSAJE_REQUERIDO;
        if (servicioObjetos.esObjetoVacio(movimiento.archivo))
            errores.archivo = MENSAJE_REQUERIDO;
        return errores;
    }

    examinar = () => {
        let errores = this.validarFormulario();
        this.setState({
            errores: errores
        });

        if (servicioObjetos.esObjetoVacio(errores)) {
            this.setState({
                mostrarDialogExaminar: true
            });
        }
        return errores;
    }

    cerrarModalExaminar = () => {
        this.setState({
            mostrarDialogExaminar: false
        });
    }

    imprimirPdf=()=>{
    let {datosImprocesados, objetoPdf} = this.state;
    if(datosImprocesados.length>0){
        if(objetoPdf.tipoDocumento==="1"){
            servicioArchivos.descargaArchivo('/importar/reporte_datos_afiliatorios_improcedentes.json', objetoPdf);
        }
        if(objetoPdf.tipoDocumento==="2"){
            servicioArchivos.descargaArchivo('/importar/reporte_datos_afiliatorios_improcedentes.json', objetoPdf);
        }
        if(objetoPdf.tipoDocumento==="3"){
            servicioArchivos.descargaArchivo('/importar/reporte_datos_afiliatorios_improcedentes.json', objetoPdf);
        }
        if(objetoPdf.tipoDocumento==="4"){
            servicioArchivos.descargaArchivo('/importar/reporte_credito_improcedentes.json', objetoPdf);
        }
        if(objetoPdf.tipoDocumento==="5"){
            servicioArchivos.descargaArchivo('/importar/reporte_incapacidades_improcedentes.json', objetoPdf);  
        }
       

    }else{
        this.growl.show({ severity: 'error', summary: 'Aviso', detail: "No hay movimiento improcedentes", life: 6000 }); 
    }
    }


    render() {
        let { datosImprocesados,respuesta, movimiento, tiposImportacion, errores, mostrarDialogExaminar, nombreArchivo } = this.state;

        const pieDialogoExaminar = (
            <div>
                <Button icon="pi-md-check" onClick={this.enviarArchivo} label="Si" className="p-button-success" />
                <Button icon="pi-md-close" onClick={this.cerrarModalExaminar} label="No" className="p-button-danger flat-btn" />
            </div>
        );

        return (
            <div>
                <Growl ref={(el) => this.growl = el} />
                <div className="p-grid">

                    <div className="p-col-12 p-md-12">
                        <label></label>
                    </div>
                    <div className="p-col-12 p-md-12">
                        <label><strong>SELECCIONE EL TIPO DE IMPORTACIÓN QUE DESEE:</strong></label>
                    </div>
                    <div className="p-col-12 p-md-5">
                        <Dropdown appendTo={document.body} id="movimiento.tipoArchivo" name="movimiento.tipoArchivo"
                            placeholder="SELECCIONE UNA OPCIÓN:" value={movimiento.tipoArchivo || ""} className={errores.tipoArchivo ? "p-error" : ""}
                            options={tiposImportacion} onChange={(e) => { this.asignarValores(e, false) }}
                            optionLabel="label" autoWidth={false} style={{ width: "100%" }} />
                        {errores.tipoArchivo ? <Message severity="error" text={errores.tipoArchivo} /> : null}
                    </div>
                    <div className="p-col-12 p-md-7">
                        <div className="card">
                            <InputTextarea id="respuesta.mensaje" value={respuesta.mensaje} onChange={(e) => this.setState({ mensaje: e.target.value })} rows={3}
                                style={{ width: "100%" }} />
                        </div>
                    </div>

                    <div className="p-col-12 p-md-12">
                        <label></label>
                    </div>

                    <div className="p-col-12">
                        <div className="p-fluid p-grid">
                            <div className="p-col-12 p-md-2">
                                <label style={{ width: "100%" }}><strong>ARCHIVO A IMPORTAR:</strong></label>
                            </div>
                            <div className="p-col-12 p-md-10">
                                <Archivo id="movimiento" nombre="movimiento.archivo" value={movimiento.archivo} etiqueta="SELECCIONE ARCHIVO" cambio={this.cargarArchivo} aceptar=".txt"
                                    style={{ width: "100%" }} />
                                {errores.archivo ? <div><br /> <Message severity="error" text={errores.archivo} /> </div> : null}
                            </div>
                        </div>
                    </div>

                    <div className="p-col-12 p-md-12">
                        <label></label>
                    </div>

                    <div className="p-col-12 p-md-12">
                        <DataTable  value={datosImprocesados}  scrollable responsive={true}>
                            <Column field="numeroSeguroSocial" header="DATOS IMPORTADOS (IMPROCEDENTES)" style={{ width: '60px' }} autoLayout={true} />
                            <Column field="descripcionError" header="ERROR ENCONTRADO" style={{ width: '60px' }} autoLayout={true} />
                        </DataTable>
                    </div>

                    <Dialog style={{ width: '50%', height: '40%' }} appendTo={document.body} header="Importar Datos" visible={mostrarDialogExaminar}
                        modal={true} onHide={this.cerrarModalExaminar} footer={pieDialogoExaminar} responsive={true}>
                        <center><h2 icon="pi pi-info-circle">Se procederá a Importar los Datos del
                            archivo:</h2></center>
                        <center><h2>{nombreArchivo}</h2></center>
                        <center><h2>¿Desea continuar?</h2></center>
                    </Dialog>

                </div>
            </div>);
    }
}



